import {
  CardActionArea,
  ClickAwayListener,
  Container,
  Menu,
  MenuItem,
  Grid,
  Box,
  Card,
  Tooltip,
  IconButton,
  Chip,
  CardContent,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import {
  Check,
  BusinessCenter as BusinessCenterIcon,
  LogoutOutlined,
  LoginOutlined,
  Sms as SmsIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  ArrowBackIos as ArrowBackIosIcon,
  AccountCircle as AccountCircleIcon,
  CalendarMonth as CalendarMonthIcon,
} from "@mui/icons-material";

import App from "./App";

import { useContext, useEffect, useState, useRef } from "react";

import ImageGallery from "./ImageGallery";
import _ from "lodash";

import { AuthContext } from "../index";
import { GlobalDataContext } from "../index";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "./MainScreen.css";

import ItemsListV2 from "./ItemsListV2";
import { getImage, getImageV2 } from "../utils/getImage";

import {
  getHourMinutes,
  getDay,
  today,
  startOfDay,
  endOfDay,
  now,
} from "../utils/dateTime";
import { fillById as fillByIdUtil } from "../utils/lists";
import React from "react";
import SwipableImageCarousel from "./SwipableImageCarousel";
import BIM_LOGO from "../images/bim_logo_100.png";

function VisitsScreen() {
  const { filters, setFilters } = useContext(GlobalDataContext);
  const { id, userId, phoneNumber, onLogin, onLogout } =
    useContext(AuthContext);

  const navigate = useNavigate();
  const [accountRef, setAccountRef] = React.useState(null);
  const accountMenuRef = React.useRef(null);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);

  //
  // const _getValueFromFilter = (type, filters) => {
  //     if (!filters || !filters.filter(f => f.type == type).length) {
  //         return null;
  //     }
  //
  //     return filters.filter(f => f.type == type)[0].value;
  // }
  //
  // const [services, setServices] = useState({
  //     isLoaded: false,
  //     data: [],
  //     grouped: []
  // })
  // const [locations, setLocations] = useState({
  //     isLoaded: false, data: []
  // })
  // const [serviceTemplates, setServiceTemplates] = useState({
  //     isLoaded: false, data: []
  // })
  // const DEFAULT_FILTER_INFO_STATE = {
  //     open: false,
  //     filters: [ ...filters],
  //     calendar: {
  //         open: false
  //     }
  // }
  // const [filterInfo, setFilterInfo] = useState(DEFAULT_FILTER_INFO_STATE)
  //
  //
  // const [chatDetailed, setChatDetailed] = useState(null)
  //
  // const DEFAULT_SERVICE_CONFIRM_STATE = {
  //     open: false,
  //     inProgress: false,
  //     text: '',
  //     serviceId: ''
  // };
  // const [serviceConfirm, setServiceConfirm] = useState(DEFAULT_SERVICE_CONFIRM_STATE);
  //
  // const DEFAULT_SERVICE_CONFIRM_STATUS_STATE = {
  //     open: false,
  //     isError: false
  // };
  //
  // const DEFAULT_REDIRECT_TO_AUTH_STATE = {
  //     open: false
  // }
  //
  // const [serviceConfirmStatus, setServiceConfirmStatus] = useState(DEFAULT_SERVICE_CONFIRM_STATUS_STATE);
  // const [redirectToAuth, setRedirectToAuth] = useState(DEFAULT_REDIRECT_TO_AUTH_STATE);
  //
  // const groupServicesByServiceTemplate = (funcServices = []) => {
  //     const list = funcServices.reduce((acc, curr) => {
  //         const idx = acc.findIndex(it => it.serviceTemplate.id === curr.serviceTemplate.id);
  //
  //         if (idx != -1) {
  //             const dateIdx = acc[idx].dates.findIndex(d => d?.date == getDay(curr?.timeFrame?.from))
  //
  //             if (dateIdx != -1) {
  //                 const locationIdx = acc[idx].dates[dateIdx].locations.findIndex(l => l.id == curr.location.id);
  //
  //                 if (locationIdx != -1) {
  //                     acc[idx].dates[dateIdx].locations[locationIdx].timeFrames.push(curr.timeFrame);
  //                 } else {
  //                     acc[idx].dates[dateIdx].locations.push({...curr.location, timeFrames: [curr.timeFrame]})
  //                 }
  //             } else {
  //                 acc[idx].dates.push({
  //                     date: getDay(curr?.timeFrame?.from),
  //                     locations: [ {...curr.location, timeFrames: [curr.timeFrame]} ]
  //                 })
  //             }
  //         } else {
  //             acc.push(
  //                 {
  //                     serviceTemplate: curr.serviceTemplate,
  //                     dates: [
  //                         {
  //                             date: getDay(curr?.timeFrame?.from),
  //                             locations: [{...curr.location, timeFrames: [curr.timeFrame]}]
  //                         }
  //                     ]
  //                 }
  //             );
  //         }
  //
  //         return acc;
  //     }, []);
  //
  //     return list;
  // };
  //
  // async function loadChats() {
  //     let url = `/api/v1/chats/get-chats`;
  //
  //     setChat(prevState => ({...prevState, isLoading: true}));
  //
  //     try {
  //         const resp = await axios.post(url, {});
  //         setChat({isLoading: false, data: resp.data});
  //         setChatDetailed(resp?.data?.[0]);
  //     } catch (err) { throw err; }
  // }
  //
  // useEffect(() => {
  //     loadChats();
  // }, [])
  //
  // async function loadServices() {
  //     try {
  //         const resp = await axios.post(`/api/v1/services/get`, {
  //             timeFrame: {
  //                 from: _getValueFromFilter('timeFrameFrom', filters),
  //                 to: _getValueFromFilter('timeFrameTo', filters)
  //             }
  //         });
  //
  //         setServices({
  //             isLoaded: true, data: resp.data
  //         })
  //     } catch (err) {
  //         //noop
  //     }
  // }
  //
  // useEffect(() => {
  //     if (services.isLoaded) {
  //         return;
  //     }
  //
  //     loadServices();
  // }, [services.isLoaded]);
  //
  // const [showCalendar, setShowCalendar] = useState(false);
  //
  // const _handleFilterModalOpen = () => {
  //     //todo change
  //     setFilterInfo(prevState => ({
  //         ...prevState,
  //         open: true
  //     }));
  // }
  //
  // const _handleFilterModalClose = () => {
  //     setFilterInfo(prevState => ({
  //         ...prevState,
  //         open: false
  //     }));
  // }
  //
  //
  // const _handleLocationTimeClick = (serviceTemplateId, locationId, timeFrameFrom) => {
  //     if (!userId) {
  //         setRedirectToAuth(prevState => ({...prevState, open: true}));
  //         return;
  //     }
  //
  //     const service = services?.data?.filter(service =>
  //         service?.serviceTemplate?.id == serviceTemplateId &&
  //         service?.location?.id == locationId &&
  //         service?.timeFrame?.from == timeFrameFrom
  //     )[0];
  //
  //     setServiceConfirm({
  //         // open: true,
  //         serviceId: service?.id, text: `
  //         ${fillByIdUtil(service?.serviceTemplate?.id, serviceTemplates?.data ?? [])?.title},
  //         ${getDay(service?.timeFrame?.from)}, c
  //         ${getHourMinutes(service?.timeFrame?.from)} по
  //         ${getHourMinutes(service?.timeFrame?.to)} \n
  //         по адресу: ${fillByIdUtil(service?.location?.id, locations?.data)?.address }
  //         `,
  //         customizations: service?.customizations
  //     })
  // }
  //
  // const _handleServiceBook = async ({serviceId, customizations}) => {
  //     if (!serviceId) {
  //         setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
  //         setServiceConfirmStatus({open: true, isError: true})
  //     }
  //
  //     try {
  //         setServiceConfirm(prevState => ({...prevState, inProgress: true}));
  //
  //         const resp = await axios.put(`/api/v1/services`, {
  //             id: serviceId,
  //             client: {
  //                 id: id
  //             },
  //             customizations: customizations
  //         });
  //
  //         setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
  //         setServiceConfirmStatus({open: true, isError: false})
  //
  //     } catch (err) {
  //         setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
  //         setServiceConfirmStatus({open: true, isError: true})
  //     }
  // }
  //
  // // todo finished here
  // const _getCentralChip = () => {
  //     const from = getDay(_getValueFromFilter('timeFrameFrom', filters));
  //     const to = getDay(_getValueFromFilter('timeFrameTo', filters))
  //
  //     const element = (
  //         <Stack sx={{pt: '2px', pb: '2px', alignItems: 'center', justifyContent: 'center', display: 'flex', width: '100%'}} display={'column'}>
  //             <Box
  //                 sx={{alignItems: 'center', justifyContent: 'space-between', display: 'flex', width: '100%'}}
  //             >
  //                 <Box
  //                     sx={{
  //                         width: '24px',
  //                         borderRadius: '50%',
  //                         justifyContent: 'center',
  //                         alignItems: 'center'
  //                     }}
  //                      onClick={(e) => {
  //                         e.stopPropagation();
  //                         plusDaysToDate(-1);
  //                     }}
  //                 >
  //                     {
  //                         getDay(today()) != getDay(_getValueFromFilter('timeFrameFrom', filters)) &&
  //                             getDay(_getValueFromFilter('timeFrameFrom', filters)) == getDay(_getValueFromFilter('timeFrameTo', filters)) ?
  //                             <ArrowBackIosIcon
  //                                 fontSize={'small'}
  //                                 sx={{
  //                                     color: 'gray',
  //                                     ml: 1,
  //                                     display: 'block'
  //                                 }}
  //                             />
  //                             : null
  //                     }
  //                 </Box>
  //                 <Typography fontSize={'12px'} sx={{color: 'gray'}}>
  //                     <CalendarMonthIcon sx={{fontSize: '12px', fontWeight: 'bold', pr: '2px'}}/>
  //                     { getDay(_getValueFromFilter('timeFrameFrom', filters)) }
  //                     { from != to ? <>&nbsp;&ndash;&nbsp;</> : null }
  //                     { from != to ? getDay(_getValueFromFilter('timeFrameTo', filters)) : null }
  //                 </Typography>
  //                 <Box
  //                     sx={{
  //                         width: '24px',
  //                         borderRadius: '50%',
  //                         justifyContent: 'center',
  //                         alignItems: 'center'
  //                     }}
  //                     onClick={(e) => {
  //                         e.stopPropagation();
  //                         plusDaysToDate(1);
  //                     }}
  //                 >
  //                     {
  //                         getDay(_getValueFromFilter('timeFrameFrom', filters)) == getDay(_getValueFromFilter('timeFrameTo', filters)) ?
  //                             <ArrowForwardIosIcon
  //                                 fontSize={'small'}
  //                                 sx={{
  //                                     color: "gray",
  //                                     mr: 1,
  //                                     display: 'block'
  //                                 }}
  //                             /> : null
  //                     }
  //                 </Box>
  //             </Box>
  //         </Stack>
  //     );
  //
  //     return (
  //         <Box
  //             sx={{
  //                 display: 'flex',
  //                 borderRadius: '30px',
  //                 border: '1px solid #ddd',
  //                 justifyContent: 'center',
  //                 alignItems: 'center',
  //                 p: '5px',
  //                 boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
  //             }}
  //             // onClick={() => {
  //             //    setFilterInfo(prevState => ({...prevState, open: true}));
  //             // }}
  //         >
  //             { element }
  //         </Box>
  //     );
  // }
  //
  // const handleDatePickV2 = (newDate, type) => {
  //     setFilterInfo(prevState => {
  //         let nextFilters = [...prevState?.filters ?? []];
  //
  //         if (type == 'from') {
  //             const ixFrom = nextFilters.findIndex(fltr => fltr.type == 'timeFrameFrom');
  //             if (ixFrom != -1) {
  //                 nextFilters.splice(ixFrom, 1);
  //             }
  //
  //             nextFilters.push({ type: 'timeFrameFrom', value: startOfDay(newDate/1000)});
  //         }
  //
  //         if (type == 'to') {
  //             const ixTo = nextFilters.findIndex(fltr => fltr.type == 'timeFrameTo');
  //             if (ixTo != -1) {
  //                 nextFilters.splice(ixTo, 1);
  //             }
  //
  //             nextFilters.push({ type: 'timeFrameTo', value: endOfDay(newDate/1000)});
  //         }
  //
  //         return {
  //             ...prevState,
  //             calendar: { ...prevState?.calendar, openFrom: false, openTo: false },
  //             filters: [...nextFilters]
  //         }
  //     });
  // }
  //
  // const plusDaysToDate = (day) => {
  //
  //     day = parseInt(day);
  //     setFilters(prevState => {
  //         const nextFilters = [...filters];
  //         let newDateFrom = 0;
  //         const ixFrom = nextFilters.findIndex(fltr => fltr.type == 'timeFrameFrom');
  //         if (ixFrom != -1) {
  //             newDateFrom = new Date(parseInt(nextFilters[ixFrom].value * 1000));
  //             newDateFrom.setDate(newDateFrom.getDate() + day);
  //
  //             nextFilters.splice(ixFrom, 1);
  //         }
  //
  //         let newDateTo = 0;
  //         const ixTo = nextFilters.findIndex(fltr => fltr.type == 'timeFrameTo');
  //         if (ixTo != -1) {
  //             newDateTo = new Date(parseInt(nextFilters[ixTo].value * 1000));
  //             newDateTo.setDate(newDateTo.getDate() + day);
  //
  //             nextFilters.splice(ixTo, 1);
  //         }
  //
  //         return [...nextFilters, { type: 'timeFrameFrom', value: startOfDay(newDateFrom / 1000)}, { type: 'timeFrameTo', value: endOfDay(newDateTo / 1000) }];
  //     });
  //
  // }
  //
  // useEffect(() => {
  //     setServices(prevState => ({...prevState, isLoaded: false}));
  //     setFilterInfo(DEFAULT_FILTER_INFO_STATE);
  // }, [filters])
  //
  // const handleDiscountPickV2 = () => {
  //     setFilterInfo(prevState => {
  //         const nextFilters = [...prevState?.filters ?? []];
  //         const ix = nextFilters.findIndex(fltr => fltr.type == 'discount');
  //         if (ix != -1) {
  //             const currValue = nextFilters[ix].value;
  //             nextFilters.splice(ix, 1);
  //             nextFilters.push({type: 'discount', value: !currValue})
  //         } else {
  //             nextFilters.push({type: 'discount', value: true})
  //         }
  //
  //
  //         return {
  //             ...prevState,
  //             filters: [...nextFilters]
  //         }
  //     })
  // }
  //
  //
  //
  // const handleAuthModalClose = () => {
  //     setAuthModal(prevState => ({...prevState, open: false}))
  // }
  //
  // const isPickedDateTime = (locationItem, timeFrame ) => {
  //     const filteredServices = services?.data?.filter(service => service?.id == serviceConfirm?.serviceId);
  //     if (filteredServices?.length && filteredServices[0].serviceTemplate?.id == serviceDetailed?.serviceTemplate?.id
  //         && locationItem?.id == filteredServices[0]?.location?.id
  //         && timeFrame?.from == filteredServices[0]?.timeFrame?.from) {
  //
  //         return true;
  //     }
  //     return false;
  // }
  //
  //
  // const [ serviceDetailed, setServiceDetailed ] = useState(null);
  // useEffect(() => {
  //     if (serviceDetailed == null) {
  //         setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATUS_STATE);
  //     }
  //
  // }, [serviceDetailed])
  //
  // const [ locationDetailed, setLocationDetailed ] = useState(null);
  // const [ mapDetailed, setMapDetailed ] = useState(null);
  // const [ serviceBook, setServiceBook ] = useState({ isLoaded: true })

  // new code
  const datePlaceSection = useRef(null);

  const DEFAULT_SERVICES_STATE = { isLoaded: false, data: [] };
  const [services, setServices] = useState(DEFAULT_SERVICES_STATE);

  const DEFAULT_SERVICE_DETAILED_STATE = null;
  const [serviceDetailed, setServiceDetailed] = useState(
    DEFAULT_SERVICE_DETAILED_STATE,
  );

  const DEFAULT_SERVICE_EDIT_STATE = {
    // flags
    isCancelling: false,
    isEditing: false,
    isUpdating: false,
    //errors
    //data
    data: {},
  };
  const [serviceEdit, setServiceEdit] = useState(DEFAULT_SERVICE_EDIT_STATE);

  const USER_INFO_DEFAULT_STATE = {
    isLoaded: false,
    data: {
      firstName: "",
      lastName: "",
    },
  };
  const [userInfo, setUserInfo] = useState(USER_INFO_DEFAULT_STATE);

  const DEFAULT_CHAT_STATE = {
    open: false,
    isLoading: false,
    data: [],
  };
  const [chat, setChat] = useState(DEFAULT_CHAT_STATE);

  const DEFAULT_AUTH_MODAL_STATE = {
    open: false,
  };
  const [authModal, setAuthModal] = useState(DEFAULT_AUTH_MODAL_STATE);

  // loaders & effects
  async function loadServices() {
    // const [ serviceTemplates, allLocations ] = await Promise.all([loadServiceTemplates(), loadAllLocations()]);

    try {
      const resp = await axios.post(`/api/v1/services/get`, {
        clientIds: [id],
      });
      setServices({ isLoaded: true, data: resp.data }); //fillServices(resp.data, serviceTemplates, allLocations)});
    } catch (err) {
      throw err;
    }
  }

  useEffect(() => {
    if (services.isLoaded) {
      return;
    }

    loadServices();
  }, [services.isLoaded]);

  useEffect(() => {
    if (userInfo.isLoaded || !userId) {
      return;
    }

    async function loadUser() {
      try {
        const resp = await axios.post(`/api/v1/users/get`, [userId]);

        setUserInfo((prevState) => ({
          isLoaded: true,
          data: {
            firstName: resp.data[0]?.firstName,
            lastName: resp.data[0]?.lastName,
          },
        }));
      } catch (err) {
        throw err;
      }
    }

    loadUser();
  }, [userInfo.isLoaded, userId]);

  // handlers
  const handleOpenUserMenu = (event) => {
    setAccountRef(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAccountRef(null);
  };

  const handleAuthModalOpen = () => {
    setAuthModal((prevState) => ({ ...prevState, open: true }));
  };

  const handleChatOpen = () => {
    setChat((prevState) => ({ ...prevState, open: true }));
  };
  const handleChatClose = () => {
    setChat((prevState) => ({ ...prevState, open: false }));
  };

  const handleCancelService = async (service) => {
    try {
      setServiceEdit((prevState) => ({ ...prevState, isCancelling: true }));

      const resp = await axios.put(`/api/v1/services`, {
        id: service?.id,
        client: {
          id: null,
        },
      });

      setServiceDetailed(null);
      setServices((prevState) => ({ ...prevState, isLoaded: false }));
    } catch (err) {
      throw err;
    }
    setServiceEdit((prevState) => ({ ...prevState, isCancelling: false }));
  };

  return (
    <App
      top={
        <Stack
          direction={"row"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pl: 4,
            pr: 4,
            backgroundColor: "#fcfcfc",
            // boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            isolation: "isolate",
          }}
        >
          <Container
            maxWidth={"lg"}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "65px",
            }}
          >
            <Box
              sx={{
                height: "25px",
                "&:hover": { cursor: "pointer" },
              }}
              component={"img"}
              onClick={() => navigate("/")}
              src={BIM_LOGO}
            />
            <Box>
              <Tooltip title="">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircleIcon
                    sx={{
                      fontSize: "30px",
                      color: "#e3e3e3",
                      "&:hover": { cursor: "pointer" },
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={accountRef}
                open={Boolean(accountRef)}
                sx={{ mt: "45px" }}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={handleCloseUserMenu}
              >
                {userId ? (
                  <MenuItem>
                    <Stack
                      variant={"body2"}
                      direction={"row"}
                      alignItems={"center"}
                      sx={{ justifyContent: "center", alignItems: "flex-end" }}
                      onClick={() => {
                        navigate("/visits");
                      }}
                    >
                      <Box>
                        <BusinessCenterIcon
                          fontSize="inherit"
                          verticalAlign={"center"}
                          sx={{
                            pr: 1,
                            color: "rgb(0 0 0/0.75)",
                          }}
                        />
                      </Box>
                      <Typography sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                        Мои визиты
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {userId ? (
                  <MenuItem>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      onClick={() => {
                        handleChatOpen();
                        handleCloseUserMenu();
                      }}
                    >
                      <SmsIcon
                        fontSize="inherit"
                        sx={{
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                        Чаты
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {userId ? (
                  <MenuItem>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      onClick={onLogout}
                    >
                      <LogoutOutlined
                        fontSize="inherit"
                        sx={{
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                        Выйти
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {!userId ? (
                  <MenuItem>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      onClick={() => {
                        handleAuthModalOpen();
                        handleCloseUserMenu();
                      }}
                    >
                      <LoginOutlined
                        fontSize="inherit"
                        sx={{
                          fontSize: "14px",
                          pr: 1,
                          color: "rgb(0 0 0/ 0.5)",
                        }}
                      />
                      <Typography sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                        Войти
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
              </Menu>
            </Box>
          </Container>
        </Stack>
      }
    >
      <Container maxWidth={"lg"} sx={{ pt: 4 }}>
        <Typography align={"left"} sx={{ pb: 2, fontSize: "16px" }}>
          Мои визиты
        </Typography>
        <ItemsListV2
          itemsLoading={!services.isLoaded}
          closeDetailed={() => {
            setServiceDetailed(null);
          }}
          sxExtra={{
            minWidth: {
              xs: "90%",
              sm: "80%",
              md: "70%",
            },
          }}
          items={
            services?.data?.length ? (
              services?.data
                ?.sort((a, b) => b.timeFrame?.from - a.timeFrame?.from)
                .map((item) => (
                  <Grid item md={3} sm={4}>
                    <Card
                      // elevation={1}
                      sx={{
                        display: "flex",
                        border: "none",
                        "&:focus": { outline: "none" },
                        "&:hover": { background: "transparent" },
                        p: 1,
                      }}
                      onClick={() => {
                        setServiceDetailed(item);
                      }}
                    >
                      <CardActionArea
                        disableRipple
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                        }}
                        onClick={() => {
                          setServiceDetailed(item);
                        }}
                      >
                        <Box
                          sx={{
                            borderRadius: "15px",
                            overflow: "hidden",
                          }}
                        >
                          <SwipableImageCarousel
                            images={_.slice(
                              item?.serviceTemplate?.images,
                              0,
                              1,
                            )}
                            aspectRatio={"1/1"}
                            getImage={getImage}
                            imageUrls={_.slice(
                              item?.serviceTemplate?.images?.map((it) =>
                                getImageV2(it?.id),
                              ),
                              0,
                              1,
                            )}
                            sxExtra={{
                              ...(now() > item?.timeFrame?.to && {
                                opacity: "0.5",
                              }),
                            }}
                          />
                        </Box>
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            p: 0,
                            pt: 1,
                            // height: '100%',
                            marginBottom: 0,
                            width: "100%",
                            ...(now() > item?.timeFrame?.to && {
                              color: "#999",
                            }),
                          }}
                        >
                          <Stack
                            sx={{
                              height: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <Stack>
                              {now() > item?.timeFrame?.to ? (
                                <Typography
                                  sx={{ fontSize: "10px" }}
                                  align={"left"}
                                >
                                  прошедший{" "}
                                </Typography>
                              ) : null}
                              <Typography
                                sx={{ fontSize: "10px" }}
                                align={"left"}
                              >
                                {`Визит ${getDay(item?.timeFrame?.from)} в ${getHourMinutes(item?.timeFrame?.from)}`}
                              </Typography>
                              <Typography
                                sx={{ fontSize: "10px" }}
                                align={"left"}
                              >
                                {" "}
                                {item?.serviceTemplate?.title}
                              </Typography>
                            </Stack>
                          </Stack>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))
            ) : (
              <Typography sx={{ color: "gray", fontSize: "14px" }}>
                У вас нет массажей
              </Typography>
            )
          }
          itemDetailed={
            serviceDetailed ? (
              // procedure detailed
              <ClickAwayListener onClickAway={() => setServiceDetailed(null)}>
                <Container maxWidth={"md"}>
                  <Box
                    sx={{
                      justifyContent: "space-between",
                      overflowY: "auto",
                      height: "100%",
                    }}
                  >
                    <ImageGallery
                      imageUrls={serviceDetailed?.serviceTemplate?.images?.map(
                        (it) => getImageV2(it?.id),
                      )}
                    />
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <Typography
                          align="left"
                          sx={{ pt: 2, fontSize: "16px" }}
                        >
                          {" "}
                          {serviceDetailed?.serviceTemplate?.title}{" "}
                        </Typography>
                        <Typography
                          align="left"
                          sx={{ pt: 1, fontSize: "10px", color: "gray" }}
                        >
                          {" "}
                          {serviceDetailed?.serviceTemplate?.description}{" "}
                        </Typography>
                        <Typography
                          ref={datePlaceSection}
                          sx={{ pt: 1, fontSize: "12px" }}
                          align={"left"}
                        >
                          Специалист
                        </Typography>
                        <Stack direction={"row"} sx={{ pt: 1 }}>
                          <Chip
                            size={"small"}
                            sx={{ fontSize: "10px" }}
                            color="success"
                            icon={<Check />}
                            label={"Медицинская книжка проверена"}
                          />
                        </Stack>
                        {serviceDetailed?.customizations?.cosmetics?.enabled ? (
                          <>
                            <Typography
                              sx={{ pt: 1, fontSize: "12px" }}
                              align={"left"}
                            >
                              Используемые средства
                            </Typography>
                            <Typography
                              sx={{ fontSize: "10px" }}
                              align={"left"}
                            >
                              {
                                serviceDetailed?.customizations?.cosmetics?.data?.filter(
                                  (it) => it.checked,
                                )?.[0]?.title
                              }
                            </Typography>
                          </>
                        ) : null}
                        {serviceDetailed?.customizations?.wish?.enabled ? (
                          <>
                            <Typography
                              sx={{ pt: 1, fontSize: "12px" }}
                              align={"left"}
                            >
                              Пожелания к процедуре
                            </Typography>
                            <Typography
                              sx={{ fontSize: "10px" }}
                              align={"left"}
                            >
                              {serviceDetailed?.customizations?.wish?.data}
                            </Typography>
                          </>
                        ) : null}
                        <Typography
                          sx={{ pt: 1, fontSize: "12px" }}
                          align={"left"}
                        >
                          Место
                        </Typography>
                        <Typography
                          sx={{ pt: 1, fontSize: "10px" }}
                          align={"left"}
                        >
                          {serviceDetailed?.location?.address}
                        </Typography>
                        <Box
                          sx={{
                            pt: 1,
                            borderRadius: "15px",
                            overflow: "hidden",
                            height: "300px",
                          }}
                        >
                          <iframe
                            src={serviceDetailed?.location?.mapUrl}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                          ></iframe>
                        </Box>
                        <Typography
                          sx={{ pt: 1, fontSize: "12px" }}
                          align={"left"}
                        >
                          Время
                        </Typography>
                        <Typography
                          sx={{ pt: 1, fontSize: "10px" }}
                          align={"left"}
                        >{`${getDay(serviceDetailed?.timeFrame?.from)} в ${getHourMinutes(serviceDetailed?.timeFrame?.from)}`}</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Box>
                          <Stack
                            sx={{
                              p: 2,
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                            }}
                            spacing={2}
                          >
                            <Button
                              variant={"contained"}
                              href={serviceDetailed?.data?.paymentLink}
                              sx={{
                                // flex: '1 1 50%',
                                fontSize: "12px",
                                maxWidth: "300px",
                                width: "100%",
                              }}
                            >
                              Оплатить
                            </Button>
                            <Button
                              variant={"outlined"}
                              onClick={() => {
                                handleCancelService(serviceDetailed);
                              }}
                              sx={{
                                // flex: '1 1 auto',
                                maxWidth: "300px",
                                // fontSize: '12px',
                                width: "100%",
                                color: "#cd5c5c",
                                // alignItems: 'center',
                                // verticalAlign: 'center'
                              }}
                            >
                              <Typography
                                align={"center"}
                                sx={{ fontSize: "12px" }}
                              >
                                Отменить прием
                              </Typography>
                            </Button>
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Container>
              </ClickAwayListener>
            ) : null
          }
        />
      </Container>
    </App>
  );
}

export default VisitsScreen;
